import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchData = async ({ uri }: any) => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/${uri}`);
  const result = await response.json();
  return result;
};

export default fetchData;
